import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridTemplateRows: '10% 60% 30%',
    gridTemplateAreas:
      "'title title title title''chart1 chart2 chart3 chart4''legend1 legend2 legend3 legend4'",
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
    gridArea: 'title',
  },
  subtitleContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  subtitle: {
    height: 40,
    width: 100,
    textAlign: 'center',
    textTransform: 'capitalize',
    fontWeight: 300,
    fontSize: 12,
  },
}));
